import { useEffect } from 'modules/core/hooks/useEffect'

type Props = {
  videoId: string
  isResponsive: boolean
}

function WistiaPlayer({ videoId, isResponsive }: Props) {
  useEffect(() => {
    // Wistia embed code, load the scripts asynchronously
    const script1 = document.createElement('script')
    script1.src = `https://fast.wistia.com/embed/medias/${videoId}.jsonp`
    script1.async = true
    document.body.appendChild(script1)

    const script2 = document.createElement('script')
    script2.src = 'https://fast.wistia.com/assets/external/E-v1.js'
    script2.async = true
    document.body.appendChild(script2)

    return () => {
      document.body.removeChild(script1)
      document.body.removeChild(script2)
    }
  }, [videoId])

  return (
    <>
      {isResponsive ? (
        <div
          id={videoId}
          className="wistia_responsive_padding"
          style={{ padding: '56.25% 0 0 0', position: 'relative' }}
        >
          <div
            className="wistia_responsive_wrapper"
            style={{ height: '100%', left: 0, position: 'absolute', top: 0, width: '100%' }}
          >
            <span
              className={`wistia_embed wistia_async_${videoId} popover=true videoFoam=true`}
              style={{
                display: 'inline-block',
                height: '100%',
                position: 'relative',
                width: '100%',
              }}
            />
          </div>
        </div>
      ) : (
        <span
          className={`wistia_embed wistia_async_${videoId} popover=true`}
          style={{
            height: '71px',
            display: 'inline-block',
            position: 'relative',
            top: 0,
            width: '126px',
          }}
        />
      )}
    </>
  )
}

export default WistiaPlayer
